import React from 'react';
import { ListGroup, ListGroupItem } from 'react-bootstrap';

import styles from './ResponseImportRecipes.css';
import ErrorSection from './ErrorSection';

function ResponseImportRecipes(props) {
  const { currentStep, messages, isError } = props;
  if (currentStep !== 4) {
    return null;
  }

  if (isError) {
    return (
      <div>
        <ListGroup className={styles['heading-error']}>
          <ListGroupItem className={styles['title-error']} bsStyle="danger">
            <i className="fa fa-times-circle fa-2x" />
            <div className={styles['title-error-message']}>
              <span>
                Download the Error List and re-import with the correct data.
                Click the button below to download the list.
              </span>
            </div>
          </ListGroupItem>
        </ListGroup>
        <ListGroupItem className={styles['container-error-list']}>
          <div className={styles['error-message-container']}>
            <ErrorSection messages={messages} />
          </div>
        </ListGroupItem>
      </div>
    );
  }

  return (
    <div className={styles['heading-success']}>
      <div className={styles['contain-success']}>
        <i
          className={`fa fa-check-circle fa-3x ${styles['icon-success']}`}
          aria-hidden="true"
        />
        <h5> Well Done </h5>
        <span> Your recipes have been imported successfully </span>
      </div>
    </div>
  );
}

export default ResponseImportRecipes;
